var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfxQ6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9332 13.4627C25.9332 20.6046 20.1436 26.3943 13.0018 26.3943C5.85991 26.3943 0.0703125 20.6046 0.0703125 13.4627C0.0703125 6.32085 5.85991 0.53125 13.0018 0.53125C20.1436 0.53125 25.9332 6.32085 25.9332 13.4627Z",
    fill: "#2A538F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5459 15.6387L13.126 13.4543L14.4995 12.9525L14.8411 11.6687L14.8295 11.6369L13.4775 12.1308L14.4516 8.46289H11.689L10.4151 13.2496L9.35145 13.6382L9 14.9617L10.0628 14.5734L9.31201 17.3945H16.6644L17.1357 15.6387H12.5459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfxQ6);
export default __webpack_public_path__ + "static/media/bfx_q (6).0158879ea55b40fc2b9d3b98d201c981.svg";
export { ForwardRef as ReactComponent };